import React, { useEffect, useState } from "react";
import Carousel from "react-material-ui-carousel";
import {
  Container,
  Typography,
  Box,
  Grid,
  Button,
  Card,
  CardMedia,
  Stack,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import CategoryCard, { CategoryCardProps } from "./CategoryCard";
import LeopardDress from "../../Components/Pictures/LeopardDress";
import BuiltByRetailersImage from "../../Components/Pictures/BuiltByRetailersImage";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import ShareStockLogo from "../../Components/Pictures/ShareStockLogo";


// Statically importing until i set up a bucket in azure
const kidsImage = require('../../assets/images/kids.png');
const headerImage = require('../../assets/images/headerImage.png');
const communityImage = require('../../assets/images/communityImage.png');
const buyImage = require('../../assets/images/buy_image.jpg');
const sellImage = require('../../assets/images/sell_graphic.jpg');
const shareImage = require('../../assets/images/share_graphic.jpg');
const sustainableImage = require('../../assets/images/sustainable_graphic.jpg');
const landingPageIcon1 = require('../../assets/images/landingPageIcon1.png');
const landingPageIcon2 = require('../../assets/images/landingPageIcon2.png');
// const joinOurCommunity = require('../../assets/images/contactUs.png');
const lifestyleImage = require('../../assets/images/lifestyle.png');
const menswearImage = require('../../assets/images/menswear.png');
const carousel1 = require('../../assets/images/carousel1.png');
const carousel2 = require('../../assets/images/carousel2.png');
const carousel3 = require('../../assets/images/carousel3.png');
const womenswearImage = require('../../assets/images/womenswear.png');
const three_testimonials = require('../../assets/images/three_testimonials.png');
// const testimonial1 = require('../../assets/images/testimonial1.png');
// const testimonial2 = require('../../assets/images/testimonial2.png');
// const testimonial3 = require('../../assets/images/testimonial3.png');

const communityText =`
Join our our ShareStock community of brands/wholesalers and partner with us by offering your clients HUGE perks for buying from you & let's grow BIG together!
`;

const carouselItems = [carousel1, carousel2, carousel3];

const categoryItems: Array<CategoryCardProps> = [
  {
    src: womenswearImage,
    alt: "womenswear",
    cardTitle: "Womenswear",
  },
  {
    src: menswearImage,
    alt: "menswear",
    cardTitle: "Menswear",
  },
  {
    src: lifestyleImage,
    alt: "lifestyle",
    cardTitle: "Lifestyle",
  },
  {
    src: kidsImage,
    alt: "kids",
    cardTitle: "Kids",
  },
];

// Helper to decrypt the token
const decodeToken = (token: string) => {
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken;
  } catch (error) {
    console.error('Invalid token:', error);
    return null;
  }
};


const LandingPage: React.FC = () => {
  const [userIsLoggedIn, setUserIsLoggedIn] = useState<boolean>(false);

  useEffect(() => {
    // Get the token from localStorage
    const encryptedToken = Cookies.get("authToken");
    if (encryptedToken) {
      // Decrypt the token to get user data
      const userData = decodeToken(encryptedToken) as {userName: string, userId: string, companyId: string, companyName: string};
      if (userData?.userName && userData.userId && userData.companyId) {
        setUserIsLoggedIn(true);
      }
    }
  }, []);


  return (
    <Container maxWidth={false}>
      <Container maxWidth='xl' disableGutters sx={{background: "white", px:10, py:5, gap: 5, borderRadius: "10px 10px 0 0"}}>
        {userIsLoggedIn ? (
          <>

            {/* Carousel */}
            <Container maxWidth='lg'>
              <Carousel>
                {carouselItems.map((item, index) => (
                  <Card key={`carousel-${index}`}>
                    <CardMedia component="img" image={item} />
                  </Card>
                ))}
              </Carousel>
            </Container>

            {/* Shopping Categories */}
            <Container maxWidth="lg" sx={{ my: 4 }}>
              <Grid container spacing={4}>
                {categoryItems.map((item, index) =>
                  <CategoryCard key={`categoryCard-${index}`} src={item.src} alt={item.alt} cardTitle={item.cardTitle} />
                )}
              </Grid>
            </Container>
          </>
        ) : (
          <Container maxWidth='xl' sx={{paddingLeft: 0, paddingRight: 0}}>
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  mt: -3,
                  padding: 0
                }}
              >
                <img
                  src={headerImage}
                  alt="Example"
                  style={{ width: "100%", display: "block", borderRadius: 8 }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: "55%",
                    left: "32%",
                    transform: "translate(-50%, -50%)",
                    color: "black",
                    maxWidth: "420px",
                    width: "100%"
                  }}
                  alignItems={"start"}
                >
                    <Typography
                      variant="h2"
                      color={"black"}
                      align="left"
                      gutterBottom
                      fontWeight={400}
                      fontSize={"3rem"}
                    >
                      Share. Sell. Buy.
                    </Typography>
                    <Typography align="left" variant="subtitle1" color={"black"} paragraph fontSize={"20px"} mb={6}>
                      ShareStock provides Independent Retailers a place to share inventory, liquidate stock, & get customers what they want. 
                    </Typography>
                    <Box display="flex" gap={2}>
                      <Button variant="contained" color="primary" href="/contact">
                        Get More Info
                      </Button>
                      <Button variant="contained" color="secondary" href="/signup">
                        Sign Up
                      </Button>
                    </Box>
                </Box>
              </Box>
          </Container>
          
        )}
        </Container>

      <Container maxWidth='xl' disableGutters sx={{background: "#FFD54F", p: 10, gap: 5, borderRadius: "0 0 0 0"}}>
          <Grid container spacing={0} rowGap={12}>
            {/* Share Row */}
            <Grid item xs={12} md={6} alignItems={"center"} display={"flex"} p={3} justifyContent={"center"}>
              <Stack direction={"row"} gap={1} alignItems={"center"} display={"flex"}>
                <Box maxWidth={200} alignItems={"center"} display={"flex"}>
                  <img
                    src={landingPageIcon1}
                    alt="Share"
                    style={{ width: "100%" }}
                  />
                </Box>
                <Typography variant="h1">Share</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6} alignItems="center" display="flex">
              <Box alignItems="center" display="flex" flexDirection="column">
                <Typography align="left" variant="body1" paragraph>
                  Retail buying is an art, not a science. As a retailer, you select styles and sizes that you think your customers will love. 
                  Most of the time, you do it right, but sometimes…well…not so right!
                </Typography>

                <Typography align="left" variant="body1" paragraph>
                  All too often, shop owners JUST LIKE YOU deal with too little, too much, or inventory they just can’t sell.
                </Typography>

                <Typography align="left" variant="body1" paragraph>
                  <Typography component="span" fontWeight="bold">ShareStock</Typography> is here to help…we’ve created an online community marketplace 
                  for independent retailers to share, buy, and sell their inventory.
                </Typography>
              </Box>
            </Grid>
            {/* End of Share Row */}
            {/* Sell Row */}
            <Grid item xs={12} md={6} alignItems="center" display="flex">
              <Box alignItems="center" display="flex" flexDirection="column">
                <Typography align="left" variant="body1" paragraph>
                  When you have inventory that you're ready to <Typography component="span" fontWeight="bold">SELL</Typography> you simply share or list it on <Typography component="span" fontWeight="bold">ShareStock</Typography> through your POS, you get to decide what deal you’d like to offer. The ball's in your court--whether you want to make 50% or 100%, you decide. 
                </Typography>

                <Typography align="left" variant="body1" paragraph>
                We then take your listed inventory and SHARE it with our community of ShareStockers, connecting you to a database of other <Typography component="span" fontWeight="bold">Independent Retailer Buyers</Typography> looking for what you've got!
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} alignItems={"center"} display={"flex"} p={3} justifyContent={"center"}>
              <Stack direction={"row"} gap={1} alignItems={"center"} display={"flex"}>
                <Box maxWidth={200} alignItems={"center"} display={"flex"}>
                  <img
                    src={landingPageIcon2}
                    alt="Sell"
                    style={{ width: "100%" }}
                  />
                </Box>
                <Typography variant="h1">Sell</Typography>
              </Stack>
            </Grid>
            {/* End of Sell Row */}


            {/* Buy Row */}
            <Grid item xs={12} md={6}alignItems={"center"} display={"flex"} p={3} justifyContent={"center"}>
              <Stack direction={"row"} gap={1} alignItems={"center"} display={"flex"}>
                <Box maxWidth={200} alignItems={"center"} display={"flex"}>
                  <img
                    src={communityImage}
                    alt="Buy"
                    style={{ width: "100%" }}
                  />
                </Box>
                <Typography variant="h1">Buy</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6} alignItems="center" display="flex">
              <Box alignItems="center" display="flex" flexDirection="column">
                <Typography align="left" variant="body1" paragraph>
                  It can be hard being an <Typography component="span" fontWeight="bold">Independent Retailer</Typography>. We've got to juggle buying the right merchandise, the right size, all for the right price. Customers many times want a size we've already sold and the wholesaler doesn't have it anymore so you loose the sale to your online competitor.
                </Typography>
                <Typography align="left" variant="body1" paragraph>
                  Now you can access <Typography component="span" fontWeight="bold">SHARED inventory</Typography> from thousands of other retailers just like you and service your customer so they keep coming back simply by using <Typography component="span" fontWeight="bold">ShareStock</Typography>.
                </Typography>
              </Box>
            </Grid>



            {/* Join our community */}
            {!userIsLoggedIn && (
              <>

                <Grid item xs={12} md={7} alignItems={"center"} display={"flex"}>

                <Stack direction={"column"} gap={3}>

                <Typography align="left" variant="h4" whiteSpace={"pre-wrap"}>Join our community of partners.</Typography>
                  <Typography align="left" variant="body1" whiteSpace={"pre-wrap"} paragraph>
                    {communityText}
                  </Typography>
                  <Box display="flex" gap={2}>
                    <Button variant="contained" color="primary" href="/contact">
                      Get More Info
                    </Button>
                    <Button variant="contained" color="secondary" href="/signup">
                      Sign Up
                    </Button>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} md={5} alignItems={"center"} display={"flex"} pl={3} justifyContent={"center"}>
                {/* <Box
                  component="img"
                  src={joinOurCommunity}
                  alt="Example Image"
                  sx={{
                    width: "100%", // Set width
                    maxWidth: "100%",
                    height: "auto", // Maintain aspect ratio
                  }}
                /> */}
                <ShareStockLogo size={400} />
              </Grid>
              </>
            )}

            

            {/* End of join our community */}

            <Grid item xs={12} alignItems={"center"} display={"flex"} p={0} justifyContent={"center"}>
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  paddingTop: "56.25%", // 16:9 Aspect Ratio
                }}
              >
                <iframe
                  src={"https://www.youtube.com/embed/fHbGXtHHq-0?si=XS9aD3YdddAsocrm"}
                  title="YouTube Video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: "none",
                  }}
                />
              </Box>
            </Grid>

            {/* End of Buy Row */}


            {/* What we offer */}
            <Grid item xs={12} md={8} alignItems={"flex-start"} display={"flex"} flexDirection={"column"}>
              <Typography variant="h4" gutterBottom>
                What We Offer
              </Typography>
                <Typography align="left" variant="body1" paragraph>
                  <Typography component="span" fontWeight="bold">ShareStock</Typography> provides a community of mom-and-pop retailers a <Typography component="span" fontWeight="bold">BIG leg up</Typography> on managing their inventory and keeping their valued customers happy.
                </Typography>
                <Typography align="left" variant="body1" paragraph>
                <Typography component="span" fontWeight="bold">SUCCESSFUL</Typography> solutions for some of the most painful problems an independent retailer experiences are solved with <Typography component="span" fontWeight="bold">ShareStock</Typography>.
                </Typography>
              <List sx={{ pl: 2 }}>
                <ListItem sx={{ display: "list-item", listStyleType: "disc" }}>
                  <ListItemText primary="Liquidate inventory faster" />
                </ListItem>
                <ListItem sx={{ display: "list-item", listStyleType: "disc" }}>
                  <ListItemText primary="Have more cash to pay bills & get FRESH new inventory" />
                </ListItem>
                <ListItem sx={{ display: "list-item", listStyleType: "disc" }}>
                  <ListItemText primary="Finding desired inventory for customers when you don’t have it in stock" />
                </ListItem>
              </List>
              <Typography variant="body1" sx={{ mt: 2 }}>
                Creating happy customers that keep coming back to <Typography component="span" fontWeight="bold">YOU!</Typography>
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} alignItems={"center"} display={"flex"} justifyContent={"center"}>
                <Box maxWidth={200} alignItems={"center"} display={"flex"}>
                  <LeopardDress size={450}/>
                </Box>
            </Grid>

            {/* End of what we offer */}
            

            {/* Four boxes  */}
            <Box display={"flex"} justifyContent={"space-between"} width={"100%"}>
                <Box alignItems={"flex-start"} display={"flex"} flexDirection={"column"} maxWidth={"220px"}>

                  <Box
                component="img"
                src={shareImage}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                  border: "2px solid black", // Add border
                  borderRadius: "8px", // Optional: rounded corners 
                }}
              />
              <Typography variant="h5" fontWeight={"bold"} gutterBottom>
                SHARE
              </Typography>
              <Typography variant="body1" gutterBottom paragraph align="left">
                SHARE the inventory you want to liquidate to our community of STOCKERS around the country where your inventory is needed.
              </Typography>
              </Box>
              <Box alignItems={"flex-start"} display={"flex"} flexDirection={"column"} maxWidth={"220px"}>
              <Box
                component="img"
                src={sellImage}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                  border: "2px solid black", // Add border
                  borderRadius: "8px", // Optional: rounded corners
                }}
              />
              <Typography variant="h5" fontWeight={"bold"} gutterBottom>
                SELL
              </Typography>
              <Typography variant="body1" gutterBottom paragraph align="left">
                SELL your inventory with other independent retailers that carry the same brand and move your inventory quicker, making your business more profitable.
              </Typography>
            </Box>

            <Box alignItems={"flex-start"} display={"flex"} flexDirection={"column"} maxWidth={"220px"}>
              <Box
                component="img"
                src={buyImage}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                  border: "2px solid black", // Add border
                  borderRadius: "8px", // Optional: rounded corners
                }}
              />
              <Typography variant="h5" fontWeight={"bold"} gutterBottom>
                BUY
              </Typography>
              <Typography variant="body1" gutterBottom paragraph align="left">
                BUY the products your customers want even when you don't have it in stock by linking to a community of independent retailers just like YOU!
              </Typography>
            </Box>

            <Box alignItems={"flex-start"} display={"flex"} flexDirection={"column"} maxWidth={"220px"}>
              <Box
                component="img"
                src={sustainableImage}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                  border: "2px solid black", // Add border
                  borderRadius: "8px", // Optional: rounded corners
                }}
              />
              <Typography variant="h5" fontWeight={"bold"} gutterBottom>
                SUSTAINABLE
              </Typography>
              <Typography variant="body1" gutterBottom paragraph align="left">
                Never waste products that don't sell. Find buyers for all your inventory...from individual sizes/pieces, to full size runs to fill independent retailers demand from their customers in their local markets. 
              </Typography>
            </Box>
            </Box>


            

            {/* End of four boxes */}

          </Grid>
      </Container>

      {/* Third section */}
      <Container maxWidth='xl' disableGutters sx={{background: "white", px:10, py:5, gap: 5, borderRadius: "0 0 10px 10px"}}>
        <Grid container spacing={0} rowGap={12}>
            {/* Share Row */}
            <Grid item xs={12} md={6} alignItems={"center"} display={"flex"} p={3} justifyContent={"center"}>
                <BuiltByRetailersImage size={450} />
            </Grid>
            <Grid item xs={12} md={1} />

            <Grid item xs={12} md={5} alignItems="center" display="flex">
              <Box alignItems="start" display="flex" flexDirection="column">
                <Typography align="left" variant="h4">
                  Built for Retailers,
                </Typography>
                <Typography align="left" variant="h4" paragraph>
                  by Retailers
                </Typography>

                <Typography align="left" variant="body1" paragraph>
We get it...inventory management is hard. Many times you have to buy a pre-selected case pack giving you not enough sizes you need and too much of what you can't sell...ever! OR you make a bad buying decision OR products are not like they appeared with an online purchase...leaving you with dead inventory that cost TONS by tying up cash and space. If only you could connect to another retailer caring the same line to see if their market could use what you want to liquidate.                </Typography>

                <Typography align="left" variant="body1" paragraph width={"100%"}>
                  NOW you can, with ShareStock...
                </Typography>

                <Typography align="left" variant="body1" paragraph>
                  As a member of the ShareStock community, we connect you to other independent retailers SELLING what they want to liquidate so another retailer can BUY the inventory they need. 
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} alignItems="start" display="flex">
                <Typography align="left" variant="h4">
                  What Retailers are Saying...
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Box
                component="img"
                src={three_testimonials}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                }}
              />
            </Grid>
            {/* <Grid item xs={12} md={4}>
                <Box
                component="img"
                src={testimonial1}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
                <Box
                component="img"
                src={testimonial2}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
                <Box
                component="img"
                src={testimonial3}
                alt="Example Image"
                mb={4}
                sx={{
                  width: "100%", // Set width
                  maxWidth: "100%",
                  height: "auto", // Maintain aspect ratio
                }}
              />
            </Grid> */}
            {!userIsLoggedIn && (

            <Grid item xs={12} alignItems={"center"} display={"flex"} justifyContent={"center"} flexDirection={"column"}>
              <Typography align="center" variant="h4" mb={8}>
                Reimagining how shop owners view their inventory and meet the needs of their customers.
              </Typography>
              <Box display="flex" gap={2}>
                  <Button variant="contained" color="primary" href="/contact">
                    Get More Info
                  </Button>
                  <Button variant="contained" color="secondary" href="/signup">
                    Sign Up
                  </Button>
                </Box>
            </Grid>
            )}

        </Grid>
      </Container>
      
      
    </Container>
  );
};

export default LandingPage;
